import { render, staticRenderFns } from "./payroll-detail.vue?vue&type=template&id=84f6f226&scoped=true"
import script from "./payroll-detail.vue?vue&type=script&lang=js"
export * from "./payroll-detail.vue?vue&type=script&lang=js"
import style0 from "./payroll-detail.vue?vue&type=style&index=0&id=84f6f226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f6f226",
  null
  
)

export default component.exports